import _                                                                                             from 'underscore';
import React, { FC }                                                                                 from 'react';
import { Label, Popup, PopupProps, SemanticCOLORS }                                                  from 'semantic-ui-react';
import { ENTITY_COLORIZATION, PROJECT_MILESTONE_INFO, ProjectMilestoneField, ProjectMilestoneTypes } from '../../../../../constants/ProductEnums';
import { ProjectMilestoneDate }                                                                      from '../../../../components/from-query/ProjectDetails';
import { Uuid }                                                                                      from '../../../../../types';
import { useProjectTermDictionary }                                                                  from '../../../../../hooks/useTermDictionary';
import { ProjectTimelineDateFieldObject }                                                            from '../../../../../services/ProjectService';
import { MilestoneDateIcon }                                                                         from '../../../../components/project/MilestoneDateIcon';
import { Cell, Grid }                                                                                from 'styled-css-grid';
import { TimeService }                                                                               from '../../../../../services';


interface Props {
    fieldId: Uuid | ProjectMilestoneField,
    label?: string,
    projectId?: Uuid,
    projectVersionId?: Uuid,
    date?: string,
    showDate?: boolean,
    color?: SemanticCOLORS,
    offset?: number,
    offsetUnit?: string,
    popupProps?: PopupProps,
}

const defaultProps: Props = {
    projectId:        null,
    projectVersionId: null,
    fieldId:          null,
    label:            null,
    date:             null,
    showDate:         false,
    color:            null,
    offset:           0,
    offsetUnit:       null,
    popupProps:       {}
}

const EntityDetailMilestoneLabel: FC<Pick<Props, 'color'>> = ( props ) => {

    return (
        <Label circular color={ props.color }>

            <Grid columns={ `auto auto` } rows={ 'auto' } columnGap={ '0px' } className={ 'cursor--default' }>
                <Cell middle><MilestoneDateIcon label={ null } date={ null } popup={ { disabled: true } } icon={ { color: null, inverted: true } }/></Cell>
                <Cell middle>{ props.children }</Cell>
            </Grid>

        </Label>
    )
}

const EntityDetailMilestone: FC<Props> = ( props ) => {

    let { getTerm }                                                           = useProjectTermDictionary(),
        { projectId, projectVersionId, label, fieldId, showDate, popupProps } = props;

    const usePlural = props.offset ?? [ -1, 0, 1 ].includes( props.offset ),
          unitHash  = new Map( [
              [ 'day', [ 'Day', 'Days' ] ],
              [ 'month', [ 'Month', 'Months' ] ],
              [ 'year', [ 'Year', 'Years' ] ],
              [ 'unit', [ 'Unit', 'Units' ] ],
          ] );

    const unitsSuffix = ( props.offsetUnit && unitHash.has( props.offsetUnit ) )
                        ? ( unitHash.get( props.offsetUnit )[ usePlural ? 1 : 0 ] )
                        : ( unitHash.get( 'unit' )[ usePlural ? 1 : 0 ] )

    let milestoneLabel = ( PROJECT_MILESTONE_INFO[ fieldId ]?.LABEL ?? null ) ? getTerm( PROJECT_MILESTONE_INFO[ fieldId ].LABEL ) : null,
        offsetLabel    = props.offset ? ` (${ props.offset > 0 ? '+' : '' }${ props.offset } ${ unitsSuffix })` : null;

    let colorHash = {
        [ ProjectMilestoneTypes.PROJECT_MILESTONE ]:     ENTITY_COLORIZATION.MILESTONES[ fieldId ],
        [ ProjectMilestoneTypes.CUSTOM_USER_MILESTONE ]: ENTITY_COLORIZATION.MILESTONES.CUSTOM,
    }

    return (
        <>
            <Popup
                disabled={ !showDate && !props.date }
                size={ 'small' }
                position={ 'top center' }
                content={ <>The calculated milestone date is <strong>{ TimeService.asDisplayDate( TimeService.displayDateToMoment( props.date ).add( props.offset as any, ( props.offsetUnit ?? unitsSuffix ) ) ) }</strong>.</> }
                trigger={ (
                    <div>
                        {/* No project ID passed, milestone label exists */ }
                        { !projectId && milestoneLabel && (
                            <EntityDetailMilestoneLabel color={ ( props.color ?? colorHash[ ProjectMilestoneTypes.PROJECT_MILESTONE ] ?? 'purple' ) as SemanticCOLORS }>

                                { milestoneLabel }{ offsetLabel }

                            </EntityDetailMilestoneLabel>
                        ) }

                        {/* No project ID passed, custom label given */ }
                        { !projectId && !milestoneLabel && label && (
                            <EntityDetailMilestoneLabel color={ ( props.color ?? colorHash[ ProjectMilestoneTypes.PROJECT_MILESTONE ] ?? 'purple' ) as SemanticCOLORS }>

                                { label }{ offsetLabel }

                            </EntityDetailMilestoneLabel>
                        ) }
                    </div>
                ) }
                { ...popupProps }
            />

            {/* Project ID passed */ }
            { projectId && (
                <ProjectMilestoneDate id={ projectId } projectVersionId={ projectVersionId } milestone={ fieldId }>

                    { ( field: ProjectTimelineDateFieldObject ) => {

                        const date  = TimeService.asDisplayDate( TimeService.displayDateToMoment( field.value ).add( props.offset ?? 0, 'months' ) ),
                              color = colorHash[ field.type ] ?? 'purple';

                        return (
                            <Popup
                                disabled={ !showDate }
                                size={ 'small' }
                                position={ 'top center' }
                                content={ <>The calculated milestone date is <strong>{ date }</strong>.</> }
                                trigger={ _.isFunction( props.children )
                                          ? props.children( { date, field, offsetLabel, color } )
                                          : (
                                              <div>
                                                  <EntityDetailMilestoneLabel color={ color }>

                                                      { field.label }{ offsetLabel }

                                                  </EntityDetailMilestoneLabel>
                                              </div>
                                          ) }
                                { ...popupProps }
                            />
                        )
                    } }
                </ProjectMilestoneDate>
            ) }
        </>
    );
};

EntityDetailMilestone.defaultProps = defaultProps;

export { EntityDetailMilestone }
